import React from 'react';
import PropTypes from 'prop-types'
import {AppProvider, Page, TextField, FormLayout, Button, Checkbox} from "@shopify/polaris";
import translations from '@shopify/polaris/locales/es.json';
const propTypes ={
  error_message: PropTypes.array.isRequired
}

class ForgotPasswordForm extends React.Component {
  constructor(props){
    super(props)
    this.state={
      email: "",
      error: props.error_message ? props.error_message.email : ""
    }
  }
  handleChange = field => {
    return value => this.setState({ [field]: value });
  };

  render() {
    return(
        <AppProvider i18n={translations}>
          <Page>
            <FormLayout>
              <TextField
                placeholder={I18n.t("devise.actions.placeholder_email")}
                label={I18n.t("devise.actions.email")}
                value={this.state.email}
                type="email"
                name="user[email]"
                onChange={this.handleChange("email")}
                error={this.state.error}
              >
              </TextField>

              <Button primary submit>{I18n.t("devise.actions.password_instructions")}</Button>
              <Button primary url="/users/sign_in">
                {I18n.t("devise.actions.log_in")}
              </Button>
              {/* <Button url="/auth/shopify_per_user" id="shopifyLogin">
                {I18n.t("devise.actions.log_in_spofify")}
              </Button> */}
            </FormLayout>
          </Page>
        </AppProvider>
    )

  }

}

ForgotPasswordForm.proptypes = propTypes

export default ForgotPasswordForm